<template>
  <div>
    <div v-if="isLoadingStore">
      <i class="el-icon-loading font-size-30 text-white mt-10" />
    </div>

    <div v-else class="detail-body">
      <div class="title-body">
        <h5 @click="backtoStore()">
          <i class="el-icon-arrow-left icon" />
          {{ store.name }}{{ $t('common.storeDetail') }}
        </h5>

        <div class="button-right">
          <el-button
            v-if="userInfo.type === ERolAdmin.ADMIN"
            class="btn"
            type="primary"
            @click="handleOpenEditDialog()"
          >
            {{ $t('store.editBtn') }}
          </el-button>
        </div>
      </div>

      <div class="info-body">
        <el-row>
          <el-col class="info" :offset="1">
            <div class="title">{{ $t('store.name') }}</div>
            <div class="detail">{{ store.name }}</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="info" :offset="1">
            <div class="title">{{ $t('store.email') }}</div>
            <div class="detail">{{ store.email }}</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="info" :offset="1">
            <div class="title">{{ $t('store.phone') }}</div>
            <div class="detail">{{ formatPhoneNumber(store.phone) }}</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="info" :offset="1">
            <div class="title">{{ $t('store.address') }}</div>
            <div class="detail">{{ store.address }}</div>
          </el-col>
        </el-row>
      </div>

      <modal-edit
        :openEditDialog="openEditDialog"
        @handleCloseEditDialog="handleCloseEditDialog"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const ModalEdit = () => import('./EditStoreDialog');
import * as pageRouter from '@/constants/pageRouter';
import { redirectRouter, formatPhoneNumber } from '@/helper';
import { PAGE } from '@/constants/common';
import { ERolAdmin } from '@/enums/user';

export default {
  components: { ModalEdit },
  data() {
    return {
      ERolAdmin,
      openEditDialog: false,
    };
  },
  computed: {
    ...mapGetters('store', ['isLoadingStore', 'store', 'error']),
    ...mapGetters('user', ['userInfo']),
  },
  methods: {
    formatPhoneNumber,
    ...mapActions('store', ['getDetail']),
    handleOpenEditDialog() {
      this.openEditDialog = true;
    },
    handleCloseEditDialog() {
      this.openEditDialog = false;
    },
    backtoStore() {
      redirectRouter({
        path: pageRouter.STORE,
        query: {
          freeText: this.$route.query.freeText,
          page: this.$route.query.page || PAGE,
        },
      });
    },
  },
  created() {
    const { id } = this.$router.currentRoute.params;

    this.getDetail({ id });
  },
};
</script>

<style lang="scss">
@import '@/styles/common-detail.scss';
</style>
